import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  IconButton,
  AppBar as MuiAppBar,
  Stack,
  Toolbar,
} from '@mui/material';
import ThemeSwitch from 'components/theme-switch/theme-switch.component';
import WorkspaceSelector from 'components/workspace-selector/workspace-selector.component';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectIsFullyAuthenticated } from 'redux/user/user.selectors';
import { useAppBar } from './app-bar.hooks';
import UserMenu from './user-menu/user-menu.component';
import ChangeEnv from 'components/change-env/change-env.component';

const AppBar = () => {
  const { t } = useTranslation();
  const { toggleSidebar } = useAppBar();
  const isFullyAuthenticated = useSelector(selectIsFullyAuthenticated);

  return (
    <MuiAppBar
      position="sticky"
      data-testid="Chrome.AppBar"
      sx={theme => ({
        backgroundColor: theme.palette.background.default,
        boxShadow: 'none',
        backgroundImage: 'none',
      })}
    >
      <Toolbar>
        <IconButton
          aria-label={t('AppBar.sidebarToggle.ariaLabel')}
          edge="start"
          onClick={toggleSidebar}
          sx={{ mr: 2, display: { md: 'none' } }}
          data-testid="Chrome.IconButton.Burger"
        >
          <MenuIcon />
        </IconButton>
        <Box width="250px" sx={{ display: { md: 'block', xs: 'none' } }}>
          <WorkspaceSelector />
        </Box>
        <Box sx={{ flexGrow: 1 }}></Box>
        <Stack direction="row" spacing={1}>
          <ChangeEnv />
          <ThemeSwitch />
          {isFullyAuthenticated && <UserMenu />}
        </Stack>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
